<template>
    <div class="kort">
        <div class="start">
            <ItemUtbildning :item="props.item"></ItemUtbildning>
        </div>
        <div class="end">
            <ItemSiffror :item="props.item"></ItemSiffror>
        </div>
    </div>
</template>
<script setup lang="ts">
import { defineProps, onMounted } from 'vue';
import { AstaResultItemType } from '../../types/AstaTypes';
import ItemUtbildning from './ItemUtbildning.vue';
import ItemSiffror from './ItemSiffror.vue';

onMounted(() => {
    // @ts-ignore
    (<any>$('[data-toggle="tooltip"]')).tooltip({
        animation: true,
    });
});

const props = defineProps<{
    item: AstaResultItemType,
}>();

</script>